"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidForm = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const flatten_1 = __importDefault(require("lodash/flatten"));
const uniq_1 = __importDefault(require("lodash/uniq"));
const FormQuestionType_1 = __importDefault(require("../FormQuestionType/FormQuestionType"));
function isValidForm(form, constraints) {
    var _a, _b, _c, _d;
    const rootC = constraints === null || constraints === void 0 ? void 0 : constraints.root;
    const sectC = constraints === null || constraints === void 0 ? void 0 : constraints[FormQuestionType_1.default.SECTION];
    const repC = constraints === null || constraints === void 0 ? void 0 : constraints[FormQuestionType_1.default.REPETITION];
    const qSetC = constraints === null || constraints === void 0 ? void 0 : constraints[FormQuestionType_1.default.QUESTIONSET];
    const noQs = ((_b = (_a = form === null || form === void 0 ? void 0 : form.questionTree) === null || _a === void 0 ? void 0 : _a.subQuestions) === null || _b === void 0 ? void 0 : _b.length) || 0;
    // Must have at least 1 questions
    if (!noQs)
        return { valid: false, reason: lib_i18n_1.default.t('fail-constraint-min', { min: (rootC === null || rootC === void 0 ? void 0 : rootC.min) || 1 }) };
    // No constraints - we're ok
    if (!rootC)
        return { valid: true };
    // Must fulfil MIN constraint
    if (rootC.min > 0 && noQs < rootC.min)
        return { valid: false, reason: lib_i18n_1.default.t('fail-constraint-min', { min: rootC.min }) };
    // Must fulfil MAX constraint
    if (rootC.max > 0 && noQs > rootC.max)
        return { valid: false, reason: lib_i18n_1.default.t('fail-constraint-max', { max: rootC.max }) };
    // Must fulfil ROOT types constraint
    if (rootC.types) {
        const badQTs = (0, uniq_1.default)((_c = form === null || form === void 0 ? void 0 : form.questionTree) === null || _c === void 0 ? void 0 : _c.subQuestions.filter(q => rootC.types.indexOf(q.type) < 0).map(q => q.type)).join(', ');
        if (!(badQTs === null || badQTs === void 0 ? void 0 : badQTs.length))
            return { valid: true };
        return { valid: false, reason: lib_i18n_1.default.t('fail-constraint-root-types', { types: badQTs }) };
    }
    // Must fulfil SECTION types constraint
    if (sectC === null || sectC === void 0 ? void 0 : sectC.types) {
        const badQTs = (0, uniq_1.default)((0, flatten_1.default)(Object.values(form.questions)
            .filter(q => q.type === FormQuestionType_1.default.SECTION)
            .map(q => q.subQuestions))
            .filter(q => sectC.types.indexOf(q.type) < 0)
            .map(q => q.type)).join(', ');
        if (!(badQTs === null || badQTs === void 0 ? void 0 : badQTs.length))
            return { valid: true };
        return { valid: false, reason: lib_i18n_1.default.t('fail-constraint-sect-types', { types: badQTs }) };
    }
    // Must fulfil REPETITION types constraint
    if (repC === null || repC === void 0 ? void 0 : repC.types) {
        const badQTs = (0, uniq_1.default)((0, flatten_1.default)(Object.values(form.questions)
            .filter(q => q.type === FormQuestionType_1.default.REPETITION)
            .map(q => q.subQuestions))
            .filter(q => repC.types.indexOf(q.type) < 0)
            .map(q => q.type)).join(', ');
        if (!(badQTs === null || badQTs === void 0 ? void 0 : badQTs.length))
            return { valid: true };
        return { valid: false, reason: lib_i18n_1.default.t('fail-constraint-rep-types', { types: badQTs }) };
    }
    // Must fulfil QUESTIONSET types constraint
    if ((_d = qSetC === null || qSetC === void 0 ? void 0 : qSetC.ids) === null || _d === void 0 ? void 0 : _d.length) {
        const badQSetIds = (0, uniq_1.default)(Object.values(form.questions)
            .filter(q => q.type === FormQuestionType_1.default.QUESTIONSET)
            .map(q => form.rules[q.questionId])
            .map(c => c.questionSetId)
            .filter(q => qSetC.ids.indexOf(q) < 0));
        if (!(badQSetIds === null || badQSetIds === void 0 ? void 0 : badQSetIds.length))
            return { valid: true };
        return { valid: false, reason: lib_i18n_1.default.t('fail-constraint-qsets') };
    }
    // We're Ok
    return { valid: true };
}
exports.isValidForm = isValidForm;
exports.default = isValidForm;
